import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import AsyncStatus from "./AsyncStatus";
import { ConfirmPopupProps, useConfirmPopup } from "../Hooks/useConfirmPopup";


const ConfirmPopup = (props: ConfirmPopupProps) => {

    const popup = useConfirmPopup(props);

    return (
        <Dialog
          open={props.action.isActive}
          onClose={props.action.cancel}
          aria-labelledby="confirm-dialog-title"
        >

          <DialogTitle id="confirm-dialog-title">{props.title}</DialogTitle>

          <DialogContent>
            <AsyncStatus action={popup.workerStatus} showChildrenWhenErrored={true}>
              {popup.textParts.map((part, idx) =>
                <DialogContentText key={idx}>{part}</DialogContentText>
              )}
            </AsyncStatus>
          </DialogContent>

        {!popup.workerStatus.isBusy && 
          <DialogActions>
            <Button onClick={props.action.cancel} autoFocus>{props.noText ?? 'No'}</Button>
            <Button onClick={popup.handleYes}>{props.yesText ?? 'Yes'}</Button>
          </DialogActions>
        }

        </Dialog>
    );

}

export default ConfirmPopup; 